<script>
  import { translate } from "../../../i18n/i18next.js";

  export let license
</script>

<div class="title">
  {translate("generic.license.serialNumber")}: {license.serialNumber}</div>
<div class="info">
  {#if license.standardPlanProjects && license.standardPlanProjects > 0}
    {translate("generic.project")} ({translate("mySchedule.plans.standard.name")}): {license.standardPlanProjects},
  {/if}
  {#if license.viewerPlanProjects && license.viewerPlanProjects > 0}
    {translate("generic.project")} ({translate("mySchedule.plans.viewer.name")}): {license.viewerPlanProjects},
  {/if}
  {translate("generic.license.ccu")}: {license.maxCCU}
</div>
<div class="info">
  {translate("generic.license.validityPeriod")}:
  {#if license.validityPeriod.isValid.ok}
    {license.validityPeriod.start} - {license.validityPeriod.end}
  {:else}
    <span style="color:crimson">
      {license.validityPeriod.start} - {license.validityPeriod.end}
    </span>
  {/if}
</div>
{#if license.project}
  <div class="info">
    {translate("generic.comment")}:
    {license.project}
  </div>
{/if}
